import styled from "styled-components"

const RssTitle = styled.a`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & > h3::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark}61;
  }
`

const RssContent = styled.ul`
  & > li {
    border-bottom: 1px solid ${(props) => props.theme.c_color_gradients.c_dark};
    & > a {
      color: ${(props) => props.theme.c_color_gradients.c_dark};
      & > h4 {
        &::before {
          background-color: ${(props) =>
            props.theme.b_color_gradients.b_dark}61;
        }
      }
    }
  }
`
const RssCategories = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & > li {
    border: 1px solid ${(props) => props.theme.c_color_gradients.c_dark};
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    & > a {
      color: inherit;
    }
    &:hover {
      color: ${(props) => props.theme.b_color_gradients.b_dark};
      border-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`

export { RssCategories, RssTitle, RssContent }
